// extracted by mini-css-extract-plugin
module.exports = {"container":"SaveButton_container_3azMz","containerButton":"SaveButton_containerButton_bDK54","iconSave":"SaveButton_iconSave_2O7cy","saved":"SaveButton_saved_1pOW9"};